(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('SecurityRoles', SecurityRoles);

    SecurityRoles.$inject = ['$resource'];

    function SecurityRoles ($resource) {
        var resourceUrl =  'api/security-roles/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'download' : {
                method : 'GET',
                url : 'api/security-roles/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
